class Contract {
  constructor() {
    this.init();
  }

  init() {
    this.contract_id = undefined;
    this.name = undefined;
    this.notes = undefined;
    this.deposit_notes = undefined;
    this.deposit_amount = undefined;
    this.refundable_deposit = undefined;
    this.legup_deposit_fee = undefined;
    this.stripe_deposit_fee = undefined;
    this.cost_amount = undefined;
    this.cost_frequency = undefined;
    this.is_active = undefined;
    this.is_public = undefined;
    this.selected = undefined;
    this.original_deposit_amount = undefined;
    this.original_refundable_deposit = undefined;
    this.original_legup_deposit_fee = undefined;
    this.original_stripe_deposit_fee = undefined;
  }

  copy() {
    const cp = new Contract();

    cp.contract_id = this.contract_id;
    cp.name = this.name;
    cp.notes = this.notes;
    cp.deposit_notes = this.deposit_notes;
    cp.deposit_amount = this.deposit_amount;
    cp.refundable_deposit = this.refundable_deposit;
    cp.legup_deposit_fee = this.legup_deposit_fee;
    cp.stripe_deposit_fee = this.stripe_deposit_fee;
    cp.cost_amount = this.cost_amount;
    cp.cost_frequency = this.cost_frequency;
    cp.is_active = this.is_active;
    cp.is_public = this.is_public;
    cp.selected = this.selected;
    cp.original_deposit_amount = this.original_deposit_amount;
    cp.original_refundable_deposit = this.original_refundable_deposit;
    cp.original_legup_deposit_fee = this.original_legup_deposit_fee;
    cp.original_stripe_deposit_fee = this.original_stripe_deposit_fee;

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.contract_id = obj.contract_id ? obj.contract_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.notes = obj.notes ? obj.notes : undefined;
      this.deposit_notes = obj.deposit_notes ? obj.deposit_notes : undefined;
      this.deposit_amount = obj.deposit_amount;
      this.refundable_deposit = obj.refundable_deposit;
      this.legup_deposit_fee = obj.legup_deposit_fee;
      this.stripe_deposit_fee = obj.stripe_deposit_fee;
      this.cost_amount = obj.cost_amount;
      this.is_active = obj.is_active;
      this.is_public = obj.is_public;
      this.selected = obj.selected;
      this.cost_frequency = obj.cost_frequency 
        && (['hourly', 'daily', 'weekly', 'monthly', 'annually'].indexOf(obj.cost_frequency) > -1)
        ? obj.cost_frequency : undefined;

      this.original_deposit_amount = (obj.original_deposit_amount !== undefined) ? obj.original_deposit_amount : obj.deposit_amount;
      this.original_refundable_deposit = (obj.original_refundable_deposit !== undefined) ? obj.original_refundable_deposit : obj.refundable_deposit;
      this.original_legup_deposit_fee = (obj.original_legup_deposit_fee !== undefined) ? obj.original_legup_deposit_fee : obj.legup_deposit_fee;
      this.original_stripe_deposit_fee = (obj.original_stripe_deposit_fee !== undefined) ? obj.original_stripe_deposit_fee : obj.stripe_deposit_fee;
    }
  }

  toString() {
    let result = this.name ? this.name : '';
    return result;
  }

  getId() {
    return this.contract_id;
  }

  setId(contract_id) {
    this.contract_id = contract_id ? contract_id.toString() : undefined;
  }
  
  getIsPublic() {
    return this.is_public;
  }

  setIsPublic(is_public) {
    this.is_public = is_public;
  }

  getIsActive() {
    return this.is_active;
  }

  setIsActive(is_active) {
    this.is_active = is_active;
  }

  getIsSelected() {
    return this.selected;
  }

  setIsSelected(selected) {
    this.selected = selected;
  }
  
  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getNotes() {
    return this.notes;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  getDepositNotes() {
    return this.deposit_notes;
  }

  setDepositNotes(deposit_notes) {
    this.deposit_notes = deposit_notes;
  }
  
  getDepositAmount() {
    return this.deposit_amount;
  }

  setDepositAmount(deposit_amount) {
    this.deposit_amount = deposit_amount;
  }

  getRefundableDepositAmount() {
    return this.refundable_deposit;
  }

  setRefundableDepositAmount(refundable_deposit) {
    this.refundable_deposit = refundable_deposit;
  }

  getCostAmount() {
    return this.cost_amount;
  }

  setCostAmount(cost_amount) {
    this.cost_amount = cost_amount;
  }

  getCostFrequency() {
    return this.cost_frequency;
  }

  setCostFrequency(cost_frequency) {
    this.cost_frequency = cost_frequency 
      && (['hourly', 'daily', 'weekly', 'monthly', 'annually'].indexOf(cost_frequency) > -1)
      ? cost_frequency : undefined;
  }

  // These are read-only
  getLegupDepositFee() {
    return this.legup_deposit_fee;
  }

  getStripeDepositFee() {
    return this.stripe_deposit_fee;
  }

  getOriginalDepositAmount() {
    return this.original_deposit_amount;
  }

  getOriginalRefundableDeposit() {
    return this.original_refundable_deposit;
  }

  getOriginalLegupDepositFee() {
    return this.original_legup_deposit_fee;
  }

  getOriginalStripeDepositFee() {
    return this.original_stripe_deposit_fee;
  }
}

module.exports = Contract;
